import { render } from "./Order.vue?vue&type=template&id=49b3fe18&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=49b3fe18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b3fe18"]])

export default __exports__